import PropTypes from "prop-types";
import React from "react";
import Image from "../Image";
import { ImageSourcesType } from "../Image/types";

export default function PrintableCard({ title, sources, mode, onClick }) {
  return (
    <li className="relative group">
      <PrintableCard.Cover mode={mode}>
        <PrintableCard.Content
          sources={sources}
          title={title}
          onClick={onClick}
        />
      </PrintableCard.Cover>
      <PrintableCard.Title mode={mode} title={title} />
    </li>
  );
}

function Cover({ children, mode }) {
  return (
    <div
      data-testid="printable-card-cover"
      className={`block rounded aspect-w-7 aspect-h-9 overflow-hidden transform transition duration-500 ease-in-out bg-purple md:bg-gray-500 group-hover:bg-purple ${
        mode === "dark"
          ? "shadow-darkSM group-hover:shadow-darkLG"
          : "shadow-lightSM group-hover:shadow-lightMD"
      } `}
    >
      {children}
    </div>
  );
}

function Content({ sources, title, onClick }) {
  return (
    <>
      <Image
        className="object-cover pointer-events-none transform transition duration-200 group-hover:scale-110"
        sources={sources}
        alt={title}
      />
      <button
        onClick={onClick}
        type="button"
        className="absolute inset-0 focus:outline-none"
      >
        <span className="sr-only">View details for {title}</span>
      </button>
    </>
  );
}

function Title({ title, mode }) {
  return (
    <h3
      className={`gn-text-sm px-xs mt-xs transform transition duration-200 ease-in-out ${
        mode === "dark" ? "text-white" : "text-black"
      }`}
    >
      {title}
    </h3>
  );
}

PrintableCard.Cover = Cover;
PrintableCard.Content = Content;
PrintableCard.Title = Title;

Cover.propTypes = {
  children: PropTypes.node.isRequired,
  mode: PropTypes.oneOf(["dark", "light"]),
};

Cover.defaultProps = {
  mode: "light",
};

Content.propTypes = {
  sources: ImageSourcesType.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Content.defaultProps = {
  onClick: () => {},
};

Title.propTypes = {
  mode: PropTypes.oneOf(["dark", "light"]),
  title: PropTypes.string.isRequired,
};

Title.defaultProps = {
  mode: "light",
};

PrintableCard.propTypes = {
  mode: PropTypes.oneOf(["dark", "light"]),
  onClick: PropTypes.func,
  sources: ImageSourcesType.isRequired,
  title: PropTypes.string.isRequired,
};

PrintableCard.defaultProps = {
  mode: "light",
  onClick: () => {},
};
